import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

// Resolve image paths: backend-served product photos start with /api/, frontend public assets start with /generated/
export const resolveImg = (path) => (path && path.startsWith("/api/")) ? `${BACKEND_URL}${path}` : path;

export const getCategories = async () => (await api.get("/categories")).data;
export const getCategory = async (slug) => (await api.get(`/categories/${slug}`)).data;
export const getSubcategory = async (slug) => (await api.get(`/subcategories/${slug}`)).data;
export const getProducts = async (params = {}) => (await api.get("/products", { params })).data;
export const getProduct = async (slug) => (await api.get(`/products/${slug}`)).data;
export const getCollection = async (kind, limit = 8) => (await api.get(`/products/collections/${kind}`, { params: { limit } })).data;
export const getIndustries = async () => (await api.get("/industries")).data;
export const getIndustry = async (slug) => (await api.get(`/industries/${slug}`)).data;
export const getBrands = async () => (await api.get("/brands")).data;
export const getTestimonials = async () => (await api.get("/testimonials")).data;
export const submitEnquiry = async (payload) => (await api.post("/enquiries", payload)).data;
export const submitTradeAccount = async (payload) => (await api.post("/trade-accounts", payload)).data;
export const submitQuote = async (payload) => (await api.post("/quotes", payload)).data;
